import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import withLazyStyle from 'components/LazyStyle';
import ProgressStep from './ProgressStep';
import style from './progressStage.css?lazy';

const ProgressStage = ({ className, stepId, stepsData, level }) => {
  let foundCurrent;
  const progressStageClassNames = cc([
    className,
    'progressStage',
    {
      'progressStage--withLabels': stepsData.some((step) => !!step.label),
      'progressStage--withExtras': stepsData.some((step) => !!step.extra)
    }
  ]);

  return (
    <div className={progressStageClassNames}>
      {stepsData.map((step) => {
        const isCurrent = stepId === step.id;
        const isFulfilled = !foundCurrent && !isCurrent;
        const isDisabled = foundCurrent && !isCurrent;
        const isLast = stepsData[stepsData.length - 1] === step;
        if (isCurrent) {
          foundCurrent = true;
        }

        return (
          <Fragment key={step.id}>
            <ProgressStep
              isCurrent={isCurrent}
              isDisabled={isDisabled}
              isFulfilled={isFulfilled}
              level={level}
              step={step}
            />
            {!isLast && <div className="progressStage__connection" />}
          </Fragment>
        );
      })}
    </div>
  );
};

ProgressStage.propTypes = {
  stepId: PropTypes.string.isRequired,
  /**
   * Array of step objects having the following structure:<br><br>
   * <strong>id</strong>: Step id to match the stepId prop<br><br>
   * <strong>label</strong>: Appears above the step bubble<br><br>
   * <strong>extra</strong>: Appears below the step bubble<br><br>
   * <strong>disabledContent</strong>: The text or image that will appear inside of the bubble when not fulfilled<br><br>
   * <strong>fulfilledContent</strong>: The text or image that will appear inside of the bubble when fulfilled<br><br>
   * <strong>replaceBG</strong>: Whether the provided image is stand alone and doesn't need the bubble<br><br>
   * <strong>tooltipText</strong>: The text that will appear inside the tooltip on hover<br><br>
   * <strong>onClick</strong>: Handler for clicks on fulfilled and not current steps
   */
  stepsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      extra: PropTypes.string,
      disabledContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      fulfilledContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      replaceBG: PropTypes.bool,
      tooltipText: PropTypes.string,
      onClick: PropTypes.func
    })
  ).isRequired,
  className: PropTypes.string,
  level: PropTypes.oneOf(['info', 'warn', 'danger'])
};

ProgressStage.defaultProps = {
  className: '',
  level: 'info'
};

export default memo(withLazyStyle(style)(ProgressStage));
